module.exports = __webpack_public_path__ + "img/redacao-nota-1000.e59ec2e6.png";